export const creditCardLimitChange = {
    displayAuthorizedBalance: true,
    types: ['CREDIT', 'PREPAID'],
};
